// extracted by mini-css-extract-plugin
export default {"validationError":"SubscriptionGiftDetailsForm_validationError__O3MML"};